export enum SectionHeaderSize {
    Small = "Small",
    Medium = "Medium",
    Large = "Large"
}